module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "missin"
  }, [_c('navbar'), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('md-card', [_c('md-card-content', [_vm._v("\n\t\t\t\tSajnos a keresett oldal nem található\n\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7af6c696!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MissingView.vue
// module id = 424
// module chunks = 2